/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import Alert from 'react-bootstrap/Alert';
import { Badge } from 'react-bootstrap';
import { Col, Row } from 'react-bootstrap';
import defaultAvatar from 'assets/img/team/avatar.png';
import AdvanceList from '../common/AdvanceList';
import DirectoryService from '../directory/DirectoryService';
import EmployeePaymentModal from './EmployeePaymentModal';
import Avatar from 'components/common/Avatar';

const UserList = () => {
  const [data, setData] = useState();
  const [users, setUsers] = useState();

  const [error, setError] = useState('');
  const [noDataToShow, setNoDataToShow] = useState(true);

  const [employeeIdentifier, setEmployeeIdentifier] = useState();
  const [openEmployeeModal, setOpenEmployeeModal] = useState(false);
  const columns = [
    {
      accessor: 'name',
      Header: 'Name',
      Cell: ({ cell }) => {
        const picture = cell.row.original.avatar;
        const name = cell.row.original.name;
        console.log(name);
        console.log(picture);
        return (
          <Row style={{ width: '80%' }}>
            <Col>
              <Avatar src={picture} />
            </Col>
            <Col className="my-2">{name}</Col>
          </Row>
        );
      }
    },
    {
      accessor: 'id',
      Header: 'ID'
    },
    {
      accessor: 'grossSalary',
      Header: 'Gross Salary'
    },
    {
      accessor: 'taxCode',
      Header: 'Tax Code'
    },
    {
      accessor: 'status',
      Header: 'Status',
      Cell: ({ cell }) => {
        const status = cell.value;
        const bg =
          status === 'Paid'
            ? 'success'
            : status === 'Pending'
            ? 'warning'
            : 'secondary';
        return (
          <Badge bg={bg} className="float-end">
            {status}
          </Badge>
        );
      }
    },
    {
      accessor: 'department',
      Header: 'Department'
    },
    {
      accessor: 'identifier',
      Header: 'Actions',
      Cell: ({ cell }) => {
        // const url = '/social/directory/user-details/' + cell.value;
        return (
          <i
            className="fas fa-edit text-blue-600"
            style={{ fontSize: '14px', color: 'gray' }}
            onClick={() => {
              console.log('Edit User', cell.value);
              setEmployeeIdentifier(cell.value);
              setOpenEmployeeModal(true);
            }}
            onMouseOver={e => {
              e.currentTarget.style.cursor = 'pointer';
            }}
          ></i>
        );
      }
    }
  ];
  const refreshEmployeeList = () => {
    console.log(users);
    DirectoryService.retrieveUsersByAccount()
      .then(data => {
        setUsers(data);
        setData(
          data.map(x => ({
            id: x.employeeNumber,
            name: x.firstName + ' ' + x.lastName,
            grossSalary: '£' + x.contract?.grossSalary || '0.00',
            taxCode: x.contract?.taxCode || 'N/A',
            department: x.contract?.department || 'N/A',
            avatar: x.avatar || defaultAvatar,
            status:
              x.contract?.payments.length > 0
                ? x.contract.payments[0].status
                : 'Pending',
            identifier: x.identifier
          }))
        );
        setNoDataToShow(!data.length > 0);
        console.log(data);
      })
      .catch(error => setError({ error: error.message }));
  };
  const handleClose = () => {
    setOpenEmployeeModal(false);
    refreshEmployeeList();
  };
  useEffect(() => {
    refreshEmployeeList();
  }, []);
  return (
    <>
      {error}
      {noDataToShow && (
        <Alert key="warning" variant="warning">
          There's not any User to show. Let's create a new one!
        </Alert>
      )}
      {data && (
        <AdvanceList
          columns={columns}
          data={data}
          selection={true}
          searchBox={true}
          bulkActions={true}
        />
      )}
      <EmployeePaymentModal
        identifier={employeeIdentifier}
        setOpenModal={handleClose}
        isOpen={openEmployeeModal}
      />
    </>
  );
};

export default UserList;
